import React from "react";
import { Box, Grid, Paper, Typography, Button } from "@mui/material";

// Replace these with your real assets
import watermark from "assets/images/wavelight/hhexagon-watermark.png";
import { BookAppointmentButton } from "components";
 

const steps = [
  {
    step: 1,
    title: "3D Eye Mapping with InnovEyes SightMap",
    desc:
      "Your eye’s unique structure is scanned to create a precise 3D digital model — the foundation for truly personalized correction",
  },
  {
    step: 2,
    title: "AI-Powered Treatment Design with Ray Tracing",
    desc:
      "Advanced AI simulates light pathways through your eye to craft a treatment plan tailored for unmatched accuracy and vision clarity.",
  },
  {
    step: 3,
    title: "Custom Laser Correction for Lasting Clarity",
    desc:
      "The personalized plan guides the laser for precise, bladeless correction — ensuring sharper, stable vision over time",
  },
];

const StepsSection = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { md: 12, xs: 8 },
        px: { md: 14, xs: 3 },
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#fff",
        backgroundImage: `url(${watermark})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        
      }}
    >
      {/* Title */}
      <Box sx={{ textAlign: "center", mb: { md: 4, xs: 3 } }}>
        <Typography
          sx={{
            fontSize: { md: "32px", xs: "22px" },
            fontWeight: 800,
            display: "inline-block",
          }}
        >
          From Mapping To Clarity
        </Typography>

        {/* small underline */}
        <Box
          sx={{
            height: 3,
            width: 84,
            backgroundColor: "#2EAD9F",
            borderRadius: 2,
            margin: "10px auto 0",
          }}
        />

        <Typography
          sx={{
            fontSize: "13px",
            mt: 1,
            color: "#666",
            fontWeight: 500,
          }}
        >
          The 3 Steps to Perfect Sight
        </Typography>
      </Box>

      {/* Cards */}
      <Grid container spacing={4} justifyContent="center">
        {steps.map((s) => (
          <Grid key={s.step} item xs={12} md={4}>
            <Paper
              elevation={3}
              sx={{
                position: "relative",
                borderRadius: "16px",
                p: { md: 6, xs: 4 },
                minHeight: 280,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                // subtle inner shadow like design
                boxShadow: "0 8px 20px rgba(19,22,24,0.06)",
                backgroundColor: "#fff",
              }}
            >
              {/* STEP label + circle number */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 2,
                }}
              >
                <Typography sx={{ fontWeight: 800, fontSize: 20 }}>STEP</Typography>

                <Box
                  sx={{
                    ml: 1,
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    backgroundColor: "#bfeee6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 800,
                    fontSize: 18,
                    color: "#123",
                    boxShadow: "0 6px 18px rgba(46,173,159,0.08)",
                  }}
                >
                  {s.step}
                </Box>
              </Box>

              <Typography sx={{ fontWeight: 700, mb: 1, fontSize: 15 }}>
                {s.title}
              </Typography>

              <Typography sx={{ color: "#7b7b7b", fontSize: 14, lineHeight: 1.8, flex: 1 }}>
                {s.desc}
              </Typography>

              <Box sx={{ mt: 3 }}>
                <Button
                  variant="outlined"
                  sx={{
                    borderRadius: "999px",
                    borderColor: "#E6E6E6",
                    textTransform: "none",
                    fontSize: 12,
                    px: 2,
                    py: 0.5,
                    color: "#222",
                    "&:hover": { borderColor: "#D0D0D0" },
                  }}
                >
                  READ MORE
                </Button>
              </Box>
            </Paper>
          </Grid>
        ))}
        <BookAppointmentButton />
      </Grid>
    </Box>
  );
};

export default StepsSection;
